import React, {FC} from "react";
import {AppDispatchType, useSelector} from "../../../../redux/store";
import {Form, Formik} from "formik";
import SearchIcon from "@material-ui/icons/Search";
import {withStyles} from "@material-ui/styles";
import {TextField, Theme} from "@material-ui/core";
import styled from "styled-components/macro";
import {useDispatch} from "react-redux";
import {spacing} from "@material-ui/system";
import {IconButton} from "@mui/material";
import {Clear} from "@mui/icons-material";
import {clearPagedCompanies, fetchPagedCompanies} from "../../../../redux/actions/companyActions";

const SearchSpaced = styled.div(spacing);
const SearchContainer = styled(SearchSpaced)`
  display: flex;
  align-items: center;
  .MuiOutlinedInput-inputMarginDense {
    padding-top: 14px;
    padding-bottom: 14px;
  }
`
const IconContainer = styled.div`
  display:flex;
  padding: 10.5px 15px;
  cursor:pointer;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
`;
const SearchTextField = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    background: "#233145",
    borderRadius: "5px 0px 0px 5px",
    '& div': {
      border: "none",
      borderTopLeftRadius: "5px",
      borderBottomLeftRadius: "5px",
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-notchedOutline ': {
      borderColor: "transparent"
    },
  }

}))(TextField);

type PropsType = {
  search: string
  onSetPage: (page: number) => void
  onSetSearch: (text: string) => void
  onSetLoading: (state: boolean) => void
}
const CompanySearch:FC<PropsType> = ({
  search,
  onSetPage,
  onSetSearch,
  onSetLoading
}) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.authReducer.user!)

  return (
    <Formik onSubmit={values => {
      const { search } = values;
      dispatch(async (dispatch: AppDispatchType) => {
        onSetLoading(true)
        await clearPagedCompanies()
        await fetchPagedCompanies(user!.token, 1, search)(dispatch)
        onSetPage(1);
        onSetSearch(search);
        onSetLoading(false)
      })
    }} initialValues={{
      search
    }}>
      {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          resetForm
        }) => {
        return <Form onSubmit={handleSubmit}>
          <SearchContainer>
            <SearchTextField
              variant="outlined"
              id="search"
              size="small"
              value={values.search}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder={'Search by company name'}
            />
            <IconContainer onClick={handleSubmit as any}>
              <SearchIcon style={{ color: "black" }} fontSize="default" />
            </IconContainer>
            <button type="submit" style={{ display: "none" }}/>
          </SearchContainer>
        </Form>
      }}
    </Formik>
  )
}

export default CompanySearch